import "./product-specification.scss";
import { execOnLoad } from '../../scripts/helpers';
import { throttle } from 'lodash';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initCollectionPage = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const specificationItems = context.querySelectorAll('[data-specificatin]');

  if(specificationItems && specificationItems.length) {

    specificationItems.forEach(item => {
      item.addEventListener('click', function() {
        const value = this.getAttribute('data-specificatin');
        context.querySelectorAll('[data-specificatin]').forEach(el => {
          el.classList.remove('active');
        });

        context.querySelectorAll(`[data-specificatin="${value}"]`).forEach(el => {
          el.classList.add('active');
        });
      });
    });
  }

  const specificatinCellContent = context.querySelectorAll('.product-specification__cell-content [data-specificatin]');

    const spaceForTallestSpecification = specItems => {
      let tallestItem = null;
      let tallestHeight = 0;

      specItems.forEach(item => {
          const itemHeight = item.offsetHeight;
          if (itemHeight > tallestHeight) {
            tallestHeight = itemHeight;
            tallestItem = item;
          }

          item.classList.remove('product-specification__specification__container--tallest');
      });

      console.log(tallestItem);
      if (tallestItem) {
        tallestItem.classList.add('product-specification__specification__container--tallest');
      }
    };

    if (specificatinCellContent && specificatinCellContent.length) {
      window.addEventListener(
        'resize',
        throttle(
          () => spaceForTallestSpecification(specificatinCellContent),
          300,
        ),
      );
      spaceForTallestSpecification(specificatinCellContent);
    }
};

execOnLoad(window.dAgency.initCollectionPage, '.product-specification__section');

